var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Col, ErrorModal, Loading, MessageBanner, Modal, Row, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { fetchIndexQueueDeadCount, fetchSolrStats, requeueIndexQueueDeadEntries, } from "../../api/adminService";
import { useSolrReindexRun } from "../../hooks/useSolrReindexRun";
import { extractErrorMessage, formatDateTime } from "../../utils/adminJobUtils";
import styles from "./SolrAdmin.module.css";
var SOLR_STATS_QUERY_KEY = ["solrStats"];
var INDEX_QUEUE_DEAD_QUERY_KEY = ["solrIndexQueueDead"];
var formatBytes = function (bytes) {
    if (!bytes)
        return "0 B";
    var units = ["B", "KB", "MB", "GB", "TB"];
    var value = bytes;
    var unitIndex = 0;
    while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex++;
    }
    return "".concat(value.toFixed(unitIndex === 0 ? 0 : 2), " ").concat(units[unitIndex]);
};
var isCoreRunning = function (stats, coreKey) {
    var _a, _b;
    if (!stats)
        return false;
    if (coreKey === "all") {
        return stats.cores.some(function (c) { return c.reindexInProgress; });
    }
    return (_b = (_a = stats.cores.find(function (c) { return c.key === coreKey; })) === null || _a === void 0 ? void 0 : _a.reindexInProgress) !== null && _b !== void 0 ? _b : false;
};
export var SolrAdmin = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var queryClient = useQueryClient();
    var _o = useQuery(SOLR_STATS_QUERY_KEY, function () { return fetchSolrStats(ky); }, { refetchInterval: 5000 }), stats = _o.data, isLoading = _o.isLoading, error = _o.error;
    var reindex = useSolrReindexRun();
    var run = reindex.run, runId = reindex.runId, isRunning = reindex.isRunning, pollFailed = reindex.pollFailed, attachToLatest = reindex.attachToLatest, forgetStored = reindex.forgetStored;
    var _p = useState(false), errorOpen = _p[0], setErrorOpen = _p[1];
    var _q = useState(null), errorDetail = _q[0], setErrorDetail = _q[1];
    var startMutation = useMutation(function (core) { return reindex.startRun(core); }, {
        onError: function (err, core) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.error("Error starting Solr reindex of ".concat(core, ":"), err);
                        _a = setErrorDetail;
                        return [4 /*yield*/, extractErrorMessage(err)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        setErrorOpen(true);
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return queryClient.invalidateQueries(SOLR_STATS_QUERY_KEY); },
    });
    // follow a reindex started elsewhere (another tab, another admin)
    var anyCoreRunning = isCoreRunning(stats, "all");
    // null = no error; otherwise the API detail of the failed load ("" when none)
    var _r = useState(null), attachError = _r[0], setAttachError = _r[1];
    var followLatestRun = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, attachToLatest()];
                case 1:
                    _c.sent();
                    setAttachError(null);
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _c.sent();
                    console.error("Error loading the running Solr reindex:", err_1);
                    _a = setAttachError;
                    return [4 /*yield*/, extractErrorMessage(err_1)];
                case 3:
                    _a.apply(void 0, [(_b = (_c.sent())) !== null && _b !== void 0 ? _b : ""]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [attachToLatest]);
    useEffect(function () {
        if (anyCoreRunning && !runId) {
            followLatestRun();
        }
    }, [anyCoreRunning, runId, followLatestRun]);
    var runStatus = run === null || run === void 0 ? void 0 : run.status;
    useEffect(function () {
        if (runStatus && runStatus !== "RUNNING") {
            // the final state is shown now — a later page load must not show it again
            forgetStored();
            queryClient.invalidateQueries(SOLR_STATS_QUERY_KEY);
        }
    }, [runStatus, queryClient, forgetStored]);
    var finishedRun = run && run.status !== "RUNNING" ? run : null;
    var runSucceeded = (finishedRun === null || finishedRun === void 0 ? void 0 : finishedRun.status) === "DONE" && ((_a = finishedRun.failed) !== null && _a !== void 0 ? _a : 0) === 0;
    var runFailedDetail = (function () {
        var _a, _b, _c, _d;
        if (!finishedRun || runSucceeded)
            return null;
        if (finishedRun.status === "DONE") {
            return formatMessage({ id: "ui-br-agency.admin.solr.reindex.partialFailure" }, {
                core: finishedRun.core,
                indexed: (_a = finishedRun.indexed) !== null && _a !== void 0 ? _a : 0,
                skipped: (_b = finishedRun.skipped) !== null && _b !== void 0 ? _b : 0,
                failed: (_c = finishedRun.failed) !== null && _c !== void 0 ? _c : 0,
            });
        }
        return ((_d = finishedRun.error) !== null && _d !== void 0 ? _d : formatMessage({ id: "ui-br-agency.admin.solr.reindex.error" }));
    })();
    var _s = useState(null), indexRequeued = _s[0], setIndexRequeued = _s[1];
    var _t = useState(null), deadCountErrorDetail = _t[0], setDeadCountErrorDetail = _t[1];
    var _u = useQuery(INDEX_QUEUE_DEAD_QUERY_KEY, function () { return fetchIndexQueueDeadCount(ky); }, {
        retry: false,
        onSuccess: function () { return setDeadCountErrorDetail(null); },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.error("Error loading dead index entries count:", err);
                        _a = setDeadCountErrorDetail;
                        return [4 /*yield*/, extractErrorMessage(err)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    }), deadIndexEntries = _u.data, deadCountFailed = _u.isError, refetchDeadCount = _u.refetch, deadCountFetching = _u.isFetching;
    var indexRequeueMutation = useMutation(function () { return requeueIndexQueueDeadEntries(ky); }, {
        onSuccess: function (count) {
            setIndexRequeued(count);
            queryClient.invalidateQueries(INDEX_QUEUE_DEAD_QUERY_KEY);
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        console.error("Error re-queueing dead index entries:", err);
                        _a = setErrorDetail;
                        return [4 /*yield*/, extractErrorMessage(err)];
                    case 1:
                        _a.apply(void 0, [(_b = (_c.sent())) !== null && _b !== void 0 ? _b : formatMessage({ id: "ui-br-agency.admin.solr.indexQueue.error" })]);
                        setErrorOpen(true);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var isBusy = startMutation.isLoading || isRunning || anyCoreRunning;
    var isCoreBusy = function (core) {
        return (startMutation.isLoading && startMutation.variables === core) ||
            (isRunning && (run === null || run === void 0 ? void 0 : run.core) === core) ||
            isCoreRunning(stats, core);
    };
    var staleSchemaCores = (_b = stats === null || stats === void 0 ? void 0 : stats.cores.filter(function (c) { return !c.unreachable && !c.schemaUpToDate; })) !== null && _b !== void 0 ? _b : [];
    var reindexNeededCores = (_c = stats === null || stats === void 0 ? void 0 : stats.cores.filter(function (c) { return !c.unreachable && c.schemaUpToDate && c.reindexNeeded; })) !== null && _c !== void 0 ? _c : [];
    var renderLastRun = function (core) {
        var _a, _b, _c, _d;
        var indexed = (_a = core.lastReindexIndexed) !== null && _a !== void 0 ? _a : 0;
        var skipped = (_b = core.lastReindexSkipped) !== null && _b !== void 0 ? _b : null;
        var failed = (_c = core.lastReindexFailed) !== null && _c !== void 0 ? _c : 0;
        if (core.reindexInProgress) {
            return formatMessage({ id: "ui-br-agency.admin.solr.stats.lastRun.running" }, { indexed: indexed, skipped: skipped !== null && skipped !== void 0 ? skipped : 0, failed: failed });
        }
        if (!core.lastReindexFinishedAt)
            return "-";
        // A run recorded before the skipped column counted every processed title as indexed.
        var summary = formatMessage({
            id: skipped === null
                ? "ui-br-agency.admin.solr.stats.lastRun.finishedProcessed"
                : "ui-br-agency.admin.solr.stats.lastRun.finished",
        }, {
            finished: formatDateTime(core.lastReindexFinishedAt),
            indexed: indexed,
            skipped: skipped !== null && skipped !== void 0 ? skipped : 0,
            failed: failed,
        });
        return failed > 0 || core.lastReindexError ? (React.createElement("span", { className: styles.unreachableBadge, title: (_d = core.lastReindexError) !== null && _d !== void 0 ? _d : undefined }, summary)) : (summary);
    };
    var renderCoreRow = function (core) { return (React.createElement("tr", { key: core.name },
        React.createElement("td", null, core.name),
        React.createElement("td", null, core.unreachable ? (React.createElement("span", { className: styles.unreachableBadge },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.unreachable" }))) : (core.docCount.toLocaleString())),
        React.createElement("td", null, core.unreachable ? "-" : formatBytes(core.sizeInBytes)),
        React.createElement("td", null, core.unreachable ? "-" : formatDateTime(core.lastModified)),
        React.createElement("td", null, core.unreachable ? "-" : renderLastRun(core)),
        React.createElement("td", null, core.reindexInProgress && (React.createElement("span", { className: styles.runningBadge },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.running" })))))); };
    if (isLoading && !stats) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.title", tagName: "h1" }),
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.title", tagName: "h2" }),
        error && stats && (React.createElement(MessageBanner, { type: "error" }, formatMessage({ id: "ui-br-agency.admin.solr.stats.staleError" }))),
        error && !stats ? (React.createElement("div", null,
            formatMessage({ id: "ui-br-agency.modal.label.error" }),
            ":",
            " ",
            formatMessage({ id: "ui-br-agency.admin.solr.stats.error" }))) : stats ? (React.createElement("table", { className: styles.statsTable },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.core" })),
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.docCount" })),
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.size" })),
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.lastCommit" })),
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.stats.lastRun" })),
                    React.createElement("th", { "aria-label": formatMessage({
                            id: "ui-br-agency.admin.solr.stats.running",
                        }) }))),
            React.createElement("tbody", null, stats.cores.map(renderCoreRow)))) : null,
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.title", tagName: "h2" }),
        staleSchemaCores.length > 0 && (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.schema.outOfDate", values: {
                    cores: staleSchemaCores.map(function (c) { return c.name; }).join(", "),
                    fields: staleSchemaCores
                        .flatMap(function (c) {
                        var _a, _b;
                        return __spreadArray(__spreadArray([], ((_a = c.missingFields) !== null && _a !== void 0 ? _a : []), true), ((_b = c.mismatchedFields) !== null && _b !== void 0 ? _b : []), true);
                    })
                        .join(", "),
                } }))),
        staleSchemaCores.length === 0 && reindexNeededCores.length > 0 && (React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.schema.reindexNeeded", values: {
                    cores: reindexNeededCores.map(function (c) { return c.name; }).join(", "),
                } }))),
        isRunning && (React.createElement(MessageBanner, { type: "warning" },
            formatMessage({ id: "ui-br-agency.admin.solr.reindex.progress" }, {
                core: (_d = run === null || run === void 0 ? void 0 : run.core) !== null && _d !== void 0 ? _d : "",
                phase: (_e = run === null || run === void 0 ? void 0 : run.phase) !== null && _e !== void 0 ? _e : "",
                processed: (_f = run === null || run === void 0 ? void 0 : run.processed) !== null && _f !== void 0 ? _f : 0,
                indexed: (_g = run === null || run === void 0 ? void 0 : run.indexed) !== null && _g !== void 0 ? _g : 0,
                skipped: (_h = run === null || run === void 0 ? void 0 : run.skipped) !== null && _h !== void 0 ? _h : 0,
                failed: (_j = run === null || run === void 0 ? void 0 : run.failed) !== null && _j !== void 0 ? _j : 0,
            }),
            " ",
            React.createElement(Loading, null))),
        attachError !== null && (React.createElement(MessageBanner, { type: "error" },
            formatMessage({ id: "ui-br-agency.admin.solr.reindex.attachError" }),
            attachError ? " (".concat(attachError, ")") : "",
            " ",
            React.createElement(Button, { buttonStyle: "default", onClick: followLatestRun, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.retry" })))),
        pollFailed && (React.createElement(MessageBanner, { type: "error" },
            formatMessage({ id: "ui-br-agency.admin.solr.reindex.statusError" }),
            " ",
            React.createElement(Button, { buttonStyle: "default", onClick: reindex.retry, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.retry" })))),
        runSucceeded && finishedRun && (React.createElement(Modal, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.title" }), open: true, onClose: reindex.reset, dismissible: true }, formatMessage({ id: "ui-br-agency.admin.solr.reindex.success" }, {
            core: finishedRun.core,
            indexed: (_k = finishedRun.indexed) !== null && _k !== void 0 ? _k : 0,
            skipped: (_l = finishedRun.skipped) !== null && _l !== void 0 ? _l : 0,
            failed: (_m = finishedRun.failed) !== null && _m !== void 0 ? _m : 0,
        }))),
        React.createElement(ErrorModal, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.title" }), open: runFailedDetail !== null, content: runFailedDetail !== null && runFailedDetail !== void 0 ? runFailedDetail : "", onClose: reindex.reset }),
        React.createElement(ErrorModal, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.title" }), open: errorOpen, content: errorDetail !== null && errorDetail !== void 0 ? errorDetail : formatMessage({ id: "ui-br-agency.admin.solr.reindex.error" }), onClose: function () { return setErrorOpen(false); } }),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement("div", { className: styles.buttonContainer },
                    React.createElement(Button, { buttonStyle: "primary", onClick: function () { return startMutation.mutate("titles"); }, disabled: isBusy }, isCoreBusy("titles") ? (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.titles.button.loading" })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.titles.button" }))),
                    React.createElement(Button, { buttonStyle: "primary", onClick: function () { return startMutation.mutate("publishers"); }, disabled: isBusy }, isCoreBusy("publishers") ? (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.publishers.button.loading" })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.publishers.button" }))),
                    React.createElement(Button, { buttonStyle: "primary", onClick: function () { return startMutation.mutate("all"); }, disabled: isBusy }, isCoreBusy("all") ? (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.all.button.loading" })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.all.button" })))))),
        React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.indexQueue.title", tagName: "h2" }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.indexQueue.description" })),
        indexRequeued !== null && (React.createElement(MessageBanner, { type: "success", dismissible: true, onExited: function () { return setIndexRequeued(null); } },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.indexQueue.requeued", values: { count: indexRequeued } }))),
        deadCountFailed && (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.indexQueue.countError" }),
            deadCountErrorDetail ? " (".concat(deadCountErrorDetail, ")") : "",
            " ",
            React.createElement(Button, { buttonStyle: "default", onClick: function () { return refetchDeadCount(); }, disabled: deadCountFetching, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.reindex.retry" })))),
        React.createElement(Button, { onClick: function () { return indexRequeueMutation.mutate(); }, disabled: indexRequeueMutation.isLoading ||
                deadIndexEntries === undefined ||
                deadIndexEntries === 0 },
            React.createElement(FormattedMessage, { id: "ui-br-agency.admin.solr.indexQueue.requeue", values: { count: deadIndexEntries !== null && deadIndexEntries !== void 0 ? deadIndexEntries : "–" } }))));
};
